"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignPdfRowAction = SignPdfRowAction;
exports.UploadSignedRowAction = UploadSignedRowAction;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const CommonComponents_1 = require("../View/Resultsets/CommonComponents");
const MainSetupReact_1 = __importDefault(require("../React/MainSetupReact"));
const SignDocumentsModal_1 = require("./SignDocumentsModal");
const signingTexts_1 = require("./signingTexts");
const UploadSignedPanel_1 = require("./UploadSignedPanel");
/** Podpisują tylko pracownicy ENVI; pozostałym rolom serwer odmawia, więc przycisku nie pokazujemy. */
const canSign = () => MainSetupReact_1.default.isRoleAllowed(MainSetupReact_1.default.STAFF_ROLES);
/**
 * Akcja wiersza „PDF z podpisem” — niezależna od tego, co podpisujemy: o pliku mówi tylko `source`.
 * Pismo i oferta dostają tu ten sam przycisk i to samo okno; różnią się wyłącznie teksty źródła.
 */
function SignPdfRowAction({ source, layout }) {
    const [show, setShow] = (0, react_1.useState)(false);
    const [toast, setToast] = (0, react_1.useState)(null);
    if (!canSign())
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(CommonComponents_1.SignedPdfIconButton, { layout: layout, onClick: () => setShow(true) }),
        react_1.default.createElement(SignDocumentsModal_1.SignDocumentsModal, { show: show, source: source, onHide: () => setShow(false), onSigned: (count) => setToast({
                header: "Podpisano",
                message: `Podpisano ${(0, signingTexts_1.pluralFiles)(count)}. Podpisane pliki są ${source.texts.inFolder} na Dysku Google.`,
            }), onUploaded: (result) => setToast({
                header: "Wgrano podpisany plik",
                message: `Przyjęto plik podpisany przez ${result.signerName}. Zapisano: ${result.signedName}.`,
            }) }),
        react_1.default.createElement(CommonComponents_1.SuccessToast, { header: toast?.header, message: toast?.message ?? "", show: !!toast, onClose: () => setToast(null) })));
}
/** Akcja wiersza „Wgraj podpisany” — własne okno, bez przechodzenia przez program ENVI Podpis. */
function UploadSignedRowAction({ source, layout }) {
    const [show, setShow] = (0, react_1.useState)(false);
    const [toast, setToast] = (0, react_1.useState)(null);
    if (!canSign())
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(CommonComponents_1.UploadSignedPdfIconButton, { layout: layout, onClick: () => setShow(true) }),
        show && (react_1.default.createElement(react_bootstrap_1.Modal, { size: "lg", show: true, onHide: () => setShow(false), enforceFocus: false },
            react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
                react_1.default.createElement(react_bootstrap_1.Modal.Title, { as: "h5" }, `Wgraj podpisany — ${source.texts.subject}`)),
            react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
                react_1.default.createElement(UploadSignedPanel_1.UploadSignedPanel, { source: source, onUploaded: (result) => setToast(`Przyjęto plik podpisany przez ${result.signerName}. Zapisano: ${result.signedName}.`) })),
            react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", onClick: () => setShow(false) }, "Zamknij")))),
        react_1.default.createElement(CommonComponents_1.SuccessToast, { header: "Wgrano podpisany plik", message: toast ?? "", show: !!toast, onClose: () => setToast(null) })));
}
